import { render, staticRenderFns } from "./LayoutPreviewSlot.vue?vue&type=template&id=5fc56888&scoped=true"
import script from "./LayoutPreviewSlot.vue?vue&type=script&lang=js"
export * from "./LayoutPreviewSlot.vue?vue&type=script&lang=js"
import style0 from "./LayoutPreviewSlot.vue?vue&type=style&index=0&id=5fc56888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc56888",
  null
  
)

export default component.exports